/** Firebase Storage 유저 데이터 루트 (프로필·카드·퀴즈·과제 제출 등) */
export const USER_STORAGE_ROOT = 'Users';

export function buildUserStoragePath(userId: string, ...segments: string[]): string {
  return [USER_STORAGE_ROOT, userId, ...segments.filter((s) => s.length > 0)].join('/');
}

export function buildQuizQuestionImagePath(
  userId: string,
  classId: string,
  quizFolder: string,
  fileName: string
): string {
  return buildUserStoragePath(userId, classId, 'quiz', quizFolder, fileName);
}
